<template>
  <label
    class="bb-radio"
    :class="{'bb-radio_small': isSmall}"
    @click.stop
  >
    <span class="bb-radio-container" @click="statusRadio">
      <input class="bb-radio-container__input" type="radio" :name="name" :checked="checked">
       <span class="bb-radio-container__checkmark-wrapper">
       <span></span>
      </span>
    </span>
    <span
      v-if="radioText"
      class="bb-radio__text"
      :class="{'bb-radio__text_big': isBigRadioText}"
    >
      {{ radioText }}
    </span>
  </label>
</template>

<script>
export default {
  name: 'radio',
  props: ['value', 'name', 'section', 'radioText', 'checked', 'isBigRadioText', 'isSmall'],
  methods: {
    statusRadio () {
      this.$emit('radioChange', this.value, this.section)
    }
  },
  beforeMount () {
    if (this.checked) {
      this.$emit('radioChange', this.value, this.section)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../../sass/variables";

  .bb-radio {
    position: relative;
    display: inline-flex;
    min-height: 12px;
    margin-right: 29px;
    cursor: pointer;
    transition: 0.3s;

    &_small {
      margin-right: 20px;
    }

    &:hover {
      opacity: 0.8;
    }

    &-container {
      position: relative;
      cursor: pointer;
      width: 12px;

      &__checkmark-wrapper {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 12px;
        width: 12px;
        border: 1px solid $color-accent;
        box-sizing: border-box;
        border-radius: 50%;
      }

      &__checkmark {
        font-size: 0;
        color: $color-white;
        transition: all 150ms;
      }

      &__input {
        position: absolute;
        top:0;
        left: 0;
        height: 12px;
        width: 12px;
        margin: 0;
        opacity: 0;

        &:checked + span {

          span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: $color-accent;
          }
        }
      }

    }

    &__text {
      margin-left: 8px;
      font-size: 12px;
      line-height: 14px;
      font-weight: normal;

      &_big {
        font-size: 14px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/radio.vue